/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { QuoteTestExpectationDto } from "./QuoteTestExpectationDto";
import {
  QuoteTestExpectationDtoFromJSON,
  QuoteTestExpectationDtoFromJSONTyped,
  QuoteTestExpectationDtoToJSON,
  QuoteTestExpectationDtoToJSONTyped,
} from "./QuoteTestExpectationDto";
import type { LineItem } from "./LineItem";
import {
  LineItemFromJSON,
  LineItemFromJSONTyped,
  LineItemToJSON,
  LineItemToJSONTyped,
} from "./LineItem";
import type { QuoteTestExecutionDto } from "./QuoteTestExecutionDto";
import {
  QuoteTestExecutionDtoFromJSON,
  QuoteTestExecutionDtoFromJSONTyped,
  QuoteTestExecutionDtoToJSON,
  QuoteTestExecutionDtoToJSONTyped,
} from "./QuoteTestExecutionDto";
import type { Location } from "./Location";
import {
  LocationFromJSON,
  LocationFromJSONTyped,
  LocationToJSON,
  LocationToJSONTyped,
} from "./Location";
import type { QuoteTestScenarioMetadata } from "./QuoteTestScenarioMetadata";
import {
  QuoteTestScenarioMetadataFromJSON,
  QuoteTestScenarioMetadataFromJSONTyped,
  QuoteTestScenarioMetadataToJSON,
  QuoteTestScenarioMetadataToJSONTyped,
} from "./QuoteTestScenarioMetadata";

/**
 *
 * @export
 * @interface QuoteTestScenarioDetailsDto
 */
export interface QuoteTestScenarioDetailsDto {
  /**
   *
   * @type {string}
   * @memberof QuoteTestScenarioDetailsDto
   */
  scenarioId?: string;
  /**
   *
   * @type {string}
   * @memberof QuoteTestScenarioDetailsDto
   */
  groupId?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof QuoteTestScenarioDetailsDto
   */
  createdAt?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof QuoteTestScenarioDetailsDto
   */
  createdBy?: string;
  /**
   *
   * @type {string}
   * @memberof QuoteTestScenarioDetailsDto
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof QuoteTestScenarioDetailsDto
   */
  description?: string;
  /**
   *
   * @type {Array<LineItem>}
   * @memberof QuoteTestScenarioDetailsDto
   */
  lineItems?: Array<LineItem>;
  /**
   *
   * @type {Location}
   * @memberof QuoteTestScenarioDetailsDto
   */
  pickupLocation?: Location;
  /**
   *
   * @type {Location}
   * @memberof QuoteTestScenarioDetailsDto
   */
  deliveryLocation?: Location;
  /**
   *
   * @type {string}
   * @memberof QuoteTestScenarioDetailsDto
   */
  metadata?: string;
  /**
   *
   * @type {QuoteTestScenarioMetadata}
   * @memberof QuoteTestScenarioDetailsDto
   */
  parsedMetadata: QuoteTestScenarioMetadata;
  /**
   *
   * @type {Array<QuoteTestExecutionDto>}
   * @memberof QuoteTestScenarioDetailsDto
   */
  executions: Array<QuoteTestExecutionDto>;
  /**
   *
   * @type {Array<QuoteTestExpectationDto>}
   * @memberof QuoteTestScenarioDetailsDto
   */
  expectations: Array<QuoteTestExpectationDto>;
  /**
   *
   * @type {number}
   * @memberof QuoteTestScenarioDetailsDto
   */
  totalWeight: number;
  /**
   *
   * @type {number}
   * @memberof QuoteTestScenarioDetailsDto
   */
  totalVolume: number;
  /**
   *
   * @type {number}
   * @memberof QuoteTestScenarioDetailsDto
   */
  totalHandlingUnits: number;
  /**
   *
   * @type {number}
   * @memberof QuoteTestScenarioDetailsDto
   */
  density: number;
  /**
   *
   * @type {number}
   * @memberof QuoteTestScenarioDetailsDto
   */
  standardDryVanLinearFeet?: number | null;
  /**
   *
   * @type {string}
   * @memberof QuoteTestScenarioDetailsDto
   */
  loadingDiagram?: string | null;
}

/**
 * Check if a given object implements the QuoteTestScenarioDetailsDto interface.
 */
export function instanceOfQuoteTestScenarioDetailsDto(
  value: object,
): value is QuoteTestScenarioDetailsDto {
  if (!("parsedMetadata" in value) || value["parsedMetadata"] === undefined)
    return false;
  if (!("executions" in value) || value["executions"] === undefined)
    return false;
  if (!("expectations" in value) || value["expectations"] === undefined)
    return false;
  if (!("totalWeight" in value) || value["totalWeight"] === undefined)
    return false;
  if (!("totalVolume" in value) || value["totalVolume"] === undefined)
    return false;
  if (
    !("totalHandlingUnits" in value) ||
    value["totalHandlingUnits"] === undefined
  )
    return false;
  if (!("density" in value) || value["density"] === undefined) return false;
  return true;
}

export function QuoteTestScenarioDetailsDtoFromJSON(
  json: any,
): QuoteTestScenarioDetailsDto {
  return QuoteTestScenarioDetailsDtoFromJSONTyped(json, false);
}

export function QuoteTestScenarioDetailsDtoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): QuoteTestScenarioDetailsDto {
  if (json == null) {
    return json;
  }
  return {
    scenarioId: json["scenarioId"] == null ? undefined : json["scenarioId"],
    groupId: json["groupId"] == null ? undefined : json["groupId"],
    createdAt: json["createdAt"] == null ? undefined : json["createdAt"],
    createdBy: json["createdBy"] == null ? undefined : json["createdBy"],
    title: json["title"] == null ? undefined : json["title"],
    description: json["description"] == null ? undefined : json["description"],
    lineItems:
      json["lineItems"] == null
        ? undefined
        : (json["lineItems"] as Array<any>).map(LineItemFromJSON),
    pickupLocation:
      json["pickupLocation"] == null
        ? undefined
        : LocationFromJSON(json["pickupLocation"]),
    deliveryLocation:
      json["deliveryLocation"] == null
        ? undefined
        : LocationFromJSON(json["deliveryLocation"]),
    metadata: json["metadata"] == null ? undefined : json["metadata"],
    parsedMetadata: QuoteTestScenarioMetadataFromJSON(json["parsedMetadata"]),
    executions: (json["executions"] as Array<any>).map(
      QuoteTestExecutionDtoFromJSON,
    ),
    expectations: (json["expectations"] as Array<any>).map(
      QuoteTestExpectationDtoFromJSON,
    ),
    totalWeight: json["totalWeight"],
    totalVolume: json["totalVolume"],
    totalHandlingUnits: json["totalHandlingUnits"],
    density: json["density"],
    standardDryVanLinearFeet:
      json["standardDryVanLinearFeet"] == null
        ? undefined
        : json["standardDryVanLinearFeet"],
    loadingDiagram:
      json["loadingDiagram"] == null ? undefined : json["loadingDiagram"],
  };
}

export function QuoteTestScenarioDetailsDtoToJSON(
  json: any,
): QuoteTestScenarioDetailsDto {
  return QuoteTestScenarioDetailsDtoToJSONTyped(json, false);
}

export function QuoteTestScenarioDetailsDtoToJSONTyped(
  value?: QuoteTestScenarioDetailsDto | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    scenarioId: value["scenarioId"],
    groupId: value["groupId"],
    createdAt: value["createdAt"],
    createdBy: value["createdBy"],
    title: value["title"],
    description: value["description"],
    lineItems:
      value["lineItems"] == null
        ? undefined
        : (value["lineItems"] as Array<any>).map(LineItemToJSON),
    pickupLocation: LocationToJSON(value["pickupLocation"]),
    deliveryLocation: LocationToJSON(value["deliveryLocation"]),
    metadata: value["metadata"],
    parsedMetadata: QuoteTestScenarioMetadataToJSON(value["parsedMetadata"]),
    executions: (value["executions"] as Array<any>).map(
      QuoteTestExecutionDtoToJSON,
    ),
    expectations: (value["expectations"] as Array<any>).map(
      QuoteTestExpectationDtoToJSON,
    ),
    totalWeight: value["totalWeight"],
    totalVolume: value["totalVolume"],
    totalHandlingUnits: value["totalHandlingUnits"],
    density: value["density"],
    standardDryVanLinearFeet: value["standardDryVanLinearFeet"],
    loadingDiagram: value["loadingDiagram"],
  };
}
